{"boat":"Aggiungi una barca","trip":"Aggiungi uscita","task":"Aggiungi attività","inventory":"Aggiungi articolo di inventario","cost":"Aggiungi costo"}